export const PAGE_KEY = 'page';
export const LIMIT_KEY = 'limit';

const isEmpty = (v) => v === undefined || v === null || v === '';

export const parseFilterFromSearchParams = (
  searchParams,
  schema = [],
  { defaultLimit = 10 } = {}
) => {
  const filterValues = {};
  schema.forEach((f) => {
    if (!f || !f.filter) return;
    if (f.filter.type === 'dateGroup') {
      const start = searchParams.get('start_date');
      const end = searchParams.get('end_date');
      const types = searchParams.get('types');
      if (start || end || types) {
        filterValues[f.accessor] = {
          start_date: start || undefined,
          end_date: end || undefined,
          types: types || undefined,
        };
      }
    } else if (f.filter.fieldQuery) {
      const v = searchParams.get(f.filter.fieldQuery);
      if (!isEmpty(v)) filterValues[f.accessor] = v;
    }
  });
  const page = Number(searchParams.get(PAGE_KEY)) || 1;
  const limit = Number(searchParams.get(LIMIT_KEY)) || defaultLimit;
  return { filterValues, page, limit };
};

export const buildApiQueryString = (
  searchParams,
  { extra = {}, includePagination = true } = {}
) => {
  const sp = new URLSearchParams(searchParams);
  if (!includePagination) {
    sp.delete(PAGE_KEY);
    sp.delete(LIMIT_KEY);
    sp.set('pagination', 'false');
  }
  Object.entries(extra).forEach(([k, v]) => {
    if (!isEmpty(v)) sp.set(k, String(v));
  });
  const s = sp.toString();
  return s ? `?${s}` : '';
};

export const mergeFilterIntoParams = (
  prevParams,
  patch,
  { resetPage = true } = {}
) => {
  const sp = new URLSearchParams(prevParams);
  Object.entries(patch || {}).forEach(([k, v]) => {
    if (isEmpty(v)) sp.delete(k);
    else sp.set(k, v);
  });
  if (resetPage) sp.set(PAGE_KEY, '1');
  return sp;
};

export const clearFilterParams = (prevParams, schema = []) => {
  const sp = new URLSearchParams(prevParams);
  schema.forEach((f) => {
    if (!f || !f.filter) return;
    if (f.filter.type === 'dateGroup') {
      sp.delete('start_date');
      sp.delete('end_date');
      sp.delete('types');
    } else if (f.filter.fieldQuery) {
      sp.delete(f.filter.fieldQuery);
    }
  });
  sp.set(PAGE_KEY, '1');
  return sp;
};

export const legacyQueryStringToObject = (qs) => {
  if (!qs) return {};
  const trimmed = qs.startsWith('?') ? qs.slice(1) : qs;
  if (!trimmed) return {};
  const sp = new URLSearchParams(trimmed);
  return Object.fromEntries(sp.entries());
};
